import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { useCallback } from 'react';
import { useEventTracker } from '@applyboard/ui-utils';
import { ShowMore } from '@applyboard/ui-components';
import { SectionHeader, SectionTitle, TitleIcons } from "./..";
export function ProgramSummary(_ref) {
  var description = _ref.description;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var trackProgramSummaryExpanded = useCallback(function (_, isExpanded) {
    return isExpanded && trackEvent({
      event: "Programs Page - Clicked 'Show More'"
    });
  }, [trackEvent]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionHeader, {
    mb: 3,
    mx: {
      xs: 3,
      md: 0
    }
  }, /*#__PURE__*/React.createElement(TitleIcons.ProgramSummary, null), /*#__PURE__*/React.createElement(SectionTitle, null, "Program Summary")), /*#__PURE__*/React.createElement(ShowMore, {
    maxHeight: "md",
    onToggleOpen: trackProgramSummaryExpanded
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description || ''
    }
  })));
}